export enum TherapistAccessStateEnum {
  Unlimited = 'Unlimited',
  Trial = 'Trial',
  Subscribed = 'Subscribed',
  PaymentOverdue = 'PaymentOverdue',
  Locked = 'Locked'
}

/** Code im 403-Body, wenn ein Endpoint ohne aktiven Zugang aufgerufen wird. */
export const SUBSCRIPTION_REQUIRED_CODE = 'subscription-required';
